import { render, staticRenderFns } from "./ShowOrderPage.vue?vue&type=template&id=218c802e&scoped=true&"
import script from "./ShowOrderPage.vue?vue&type=script&lang=js&"
export * from "./ShowOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowOrderPage.vue?vue&type=style&index=0&id=218c802e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c802e",
  null
  
)

export default component.exports